import React from "react";
import PanelBlock from "./PanelBlock";
const Days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const Panel = ({ list, type, weekData }) => {
  const gameWeeks = weekData?.game_weeks?.split(",") || Days;
  const formattedWeeks = gameWeeks.map(week => week.substring(0, 3));
  const PanelHeading = ({ children }) => {
    return (
      <th className="py-2 italic bg-yellow-300 border-2  border-blue-600">
        {children}
      </th>
    );
  };
  return (
    <div className="p-5">
      <table className="w-full border-separate">
        <thead>
          <tr>
            <PanelHeading>DATE</PanelHeading>
            {
              formattedWeeks.map((wk, i) => (
                <PanelHeading key={`week_${i}`}>{wk}</PanelHeading>
              ))
            }
          </tr>
        </thead>
        <tbody>
          {list?.map((weekData, i) => (
            <tr key={`weekData_${weekData?.week_number}`}>
              <td className="border-2 border-blue-700 grid py-5">
                <span>{weekData?.startWeek}</span>
                <span>to</span>
                <span>{weekData?.endWeek}</span>
              </td>
              {gameWeeks.map((day, di) => {
                return (
                  <PanelBlock
                    key={`week_${i}_day_${di}`}
                    data={weekData.data?.[day]}
                    type={type}
                  />
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Panel;
